import {PayloadAction} from "@reduxjs/toolkit";
import moment from "moment";
import "moment/dist/locale/ar";
import "moment/dist/locale/de";
import "moment/dist/locale/es";
import "moment/dist/locale/fr";
import "moment/dist/locale/it";
import "moment/dist/locale/pt";
import {Reducer} from "redux";
import {INIT} from "../rootActions";
import {APP_IS_A11Y_SET, APP_LANGUAGE_SET} from "./appActions";

export type AppState = {
  license: any;
  language: string;
  languages: string[];
  themes: any[];
  isA11y: boolean;
  mapLayersConfig: any;
} | null;

const appReducer: Reducer<AppState, PayloadAction<any>> = (state = null, action) => {
  switch (action.type) {
    case INIT: {
      const language = action.payload.defaultLanguage;
      const languages = action.payload.supportedLanguages;

      const initialState = {
        license: action.payload.license,
        language: language,
        languages: languages,
        themes: action.payload.themes,
        isA11y: false,
        mapLayersConfig: action.payload.mapLayersConfig
      };

      sessionStorage.setItem("appLanguage", language);
      sessionStorage.setItem("appLanguages", languages);
      moment.locale(language);
      window.language = language;

      return initialState;
    }

    case APP_LANGUAGE_SET: {
      const language = action.payload.language;
      sessionStorage.setItem("appLanguage", language);
      moment.locale(language);
      window.language = language;

      return {
        ...state,
        language: language
      };
    }

    case APP_IS_A11Y_SET: {
      return {
        ...state,
        isA11y: action.payload.isA11y
      };
    }
    default:
      return state;
  }
};

export default appReducer;
